import BaseSeriesChart from "@/components_v2/Charts/Series/BaseSeriesChart";
import AnalyticsCard from "@/features/certifications/analytics/components/AnalyticsCard";
import { CARD_SIZES } from "@/features/certifications/analytics/constants";
import { SeriesCardProps } from "@/features/certifications/analytics/types";

const SeriesCard = ({
  title,
  info,
  aside,
  isLoading,
  isError,
  size = CARD_SIZES.FULL,
  ...chartProps
}: SeriesCardProps) => (
  <AnalyticsCard
    title={title}
    info={info}
    aside={aside}
    isLoading={isLoading}
    isError={isError}
    size={size}
  >
    <BaseSeriesChart title={title} {...chartProps} />
  </AnalyticsCard>
);

export default SeriesCard;
